export function isSubscribed(user) {

    return ["trialing", "active"].includes(user?.subscription?.status)
}
export function isActive(user) {

    return ["active"].includes(user?.subscription?.status)
}
export function isTrialing(user) {

    return ["trialing"].includes(user?.subscription?.status)
}